import React, { Component } from "react";
import { connect } from "react-redux";

import { auth } from "../actions";
import {Container, FormGroup, Col, Row, Input, Button, Alert} from 'reactstrap';
import LogoCafe from '../images/logo_cafe.png';
import Loading from "./share/Loading";

class Login extends Component {

    constructor(props){
        super(props);
        this.state = {
            numero_identificacion: "",
            password: "",
            is_authenticated: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.login(this.state.numero_identificacion, this.state.password);
    };

    componentWillReceiveProps(){
        /*this.setState({
            is_authenticated: this.props.is_authenticated
        });*/
        this.redirect();
    }

    componentDidMount(){
        this.redirect();
    }

    redirect(){
        let token = localStorage.getItem('token_cafe');
        if(!!token){
            this.props.history.push('/home');
        }
    }

    render(){

        return (
            <Container className = 'login'>
                <Row className="mt-5">
                    <img className="logo d-block m-auto" src={LogoCafe} alt="Logo"/>
                </Row>
                <Row>
                    <Col md={{size: 10, offset: 1}}>
                        <h1 className="text-center font-italic m-3">
                            Sistema inteligente de monitoreo y alertas tempranas de infección en cultivos cafeteros
                        </h1>
                    </Col>
                </Row>
                <Row>
                    <Col md={{size: 4, offset: 4}}>
                        <form onSubmit={this.handleSubmit}>
                            <h2 className="text-center mt-3">
                                Bienvenido al sistema de administración
                            </h2>
                            {
                                (!!this.props.error) ?
                                    <Alert color="danger">
                                        {this.props.error}
                                    </Alert> : ''
                            }

                            <FormGroup className="form-group mt-4">
                                <Input type="number" name="usuario" id="usuario" placeholder="Usuario" onChange={e => this.setState({ numero_identificacion: e.target.value })}/>
                            </FormGroup>
                            <FormGroup className="form-group">
                                <Input type="password" name="contrasena" id="contrasena" placeholder="Contraseña" onChange={e => this.setState({ password: e.target.value })}/>
                            </FormGroup>
                            {
                                (this.props.is_loading === true) ? <Loading/> :

                                <Col md="12" className="text-center">
                                    <Button type="submit">Ingresar</Button>
                                </Col>
                            }
                        </form>
                    </Col>
                </Row>
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        error:  state.auth.error,
        is_authenticated: state.auth.is_authenticated,
        is_loading: state.auth.is_loading
    };
};

const mapDispatchToProps = dispatch => {
    return {
        login: (numero_identificacion, password) => {
            return dispatch(auth.login(numero_identificacion, password));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);